import Image1 from '../../assets/img/portfolio/project-1.jpg';
import Image2 from '../../assets/img/portfolio/project-2.jpg';
import Image3 from '../../assets/img/portfolio/project-3.jpg';
import Image4 from '../../assets/img/portfolio/project-4.jpg';
import Image5 from '../../assets/img/portfolio/project-5.jpg';
import Image6 from '../../assets/img/portfolio/project-6.jpg';
import Image7 from '../../assets/img/portfolio/project-7.jpg';
import Image8 from '../../assets/img/portfolio/project-8.jpg';
// import Image9 from '../../assets/img/portfolio/project-9.jpg';

const PortfolioData = [
  {
    id: 1,
    type: 'React Pizza Delivery',
    image: Image1,
    tag: ['full-stack app'],
    delayAnimation: '0',
    modalDetails: [
      {
        project: 'React Pizza',
        repo: 'https://github.com/qaushqestaj/pizzadelivery',
        language: 'React (Redux, Router), TalwindCSS',
        preview: 'Preview link',
        link: 'https://react-pizzadelivery.netlify.app/',
      },
    ],
  },
  {
    id: 2,
    type: 'Dashboard management',
    image: Image2,
    tag: ['full-stack app'],
    delayAnimation: '0',
    modalDetails: [
      {
        project: 'Hotel Management',
        repo: 'https://github.com/qaushqestaj/hotelhub',
        language: 'React (Router, Query, Context), Styled Components',
        preview: 'Preview link',
        link: 'https://hotelhub-qaush.netlify.app/',
      },
    ],
  },
  {
    id: 3,
    type: 'Movie App',
    image: Image3,
    tag: ['full-stack app'],
    delayAnimation: '200',
    modalDetails: [
      {
        project: 'Watch & Rate Movies',
        repo: 'https://github.com/qaushqestaj/popcornvibes',
        language: 'JavaScript, React',
        preview: 'Preview link',
        link: 'https://popcornvibes.netlify.app/',
      },
    ],
  },
  {
    id: 4,
    type: 'WorldWise',
    image: Image4,
    tag: ['full-stack app'],
    delayAnimation: '200',
    modalDetails: [
      {
        project: 'WorldWise',
        repo: 'https://github.com/qaushqestaj/worldwise',
        language: 'React, React Router, Context API',
        preview: 'Preview link',
        link: 'https://worldwise-qaush.netlify.app/',
      },
    ],
  },

  {
    id: 5,
    type: 'Full-Stack Application',
    image: Image5,
    tag: ['full-stack app'],
    delayAnimation: '100',
    modalDetails: [
      {
        project: 'Full-Stack Application',
        client: 'Municipality of Junik',
        language: 'JS, Node.js, Django',
        preview: "Municipality's Website",
        link: 'https://kk.rks-gov.net/junik/?lang=en',
      },
    ],
  },
  {
    id: 6,
    type: 'Web Application',
    image: Image6,
    tag: ['web app'],
    delayAnimation: '200',
    modalDetails: [
      {
        project: 'Run & Cycle',
        repo: 'https://github.com/qaushqestaj/maptyapp',
        language: 'SASS, JavaScript',
        preview: 'Preview link',
        link: 'https://runandcycle.netlify.app/',
      },
    ],
  },
  {
    id: 7,
    type: 'Web Application',
    image: Image7,
    tag: ['web app'],
    delayAnimation: '200',
    modalDetails: [
      {
        project: 'Website',
        client: 'Falkonet L.L.C.',
        language: 'SASS, JavaScript',
        preview: 'Preview link',
        link: 'https://www.falkonet.com/',
      },
    ],
  },
  {
    id: 8,
    type: 'Web Application',
    image: Image8,
    tag: ['web app'],
    delayAnimation: '100',
    modalDetails: [
      {
        project: 'Split the bill',
        repo: 'https://github.com/qaushqestaj/eat-n-split',
        language: 'JavaScript, React',
        preview: 'Preview link',
        link: 'https://app-split-bill.netlify.app/',
      },
    ],
  },
  // {
  //   id: 9,
  //   type: 'Web Application',
  //   image: Image9,
  //   tag: ['web app'],
  //   delayAnimation: '200',
  //   modalDetails: [
  //     {
  //       project: 'Travel list',
  //       repo: 'https://github.com/qaushqestaj/travel-list',
  //       language: 'JavaScript, React',
  //       preview: 'Preview link',
  //       link: 'https://make-travel-list.netlify.app/',
  //     },
  //   ],
  // },
];

export default PortfolioData;
